export default __webpack_public_path__ + "static/media/saint-malo5.2eb23540.jpg";